@if (finalContainer$ | async; as finalContainer) {
  <div class="promo-card">
    @switch (finalContainer?.subType) {

      @case ('default') {
        <ng-container *ngTemplateOutlet="defaultTemplate; context:{finalContainer : finalContainer}"></ng-container>
      }
      @case ('wow') {
        <ng-container *ngTemplateOutlet="wowTemplate; context:{finalContainer : finalContainer}"></ng-container>
      }
      @case ('card') {
        <ng-container *ngTemplateOutlet="cardTemplate; context:{finalContainer : finalContainer}"></ng-container>
      }
      @case ('image_banner') {
        <ng-container *ngTemplateOutlet="imgBannerTemplate; context:{finalContainer : finalContainer}"></ng-container>
      }
      @default {
        <ng-container *ngTemplateOutlet="defaultTemplate; context:{finalContainer : finalContainer}"></ng-container>
      }
    }
  </div>
}

<ng-template #imgBannerTemplate let-finalContainer="finalContainer">
  @if (finalContainer?.image?.path) {
    <div (click)="goto(finalContainer)" class="banner-card">
      <div class="logo">
        <a class="img-wrap"
           [ngStyle]="{'width': finalContainer?.image?.width,'height': finalContainer?.image?.height,}"
           href="{{ finalContainer?.externalUrl ? finalContainer?.externalUrl : hostWebsite + compData?.container?.navigationURL }}"
           onclick="return false;"
           target="_blank"
        >
          <img
            #imgTag
            [ngSrc]="finalContainer?.image?.path + '?format=webp&quality=' + imgQuality + '&height=' + (finalContainer?.image?.minHeight ? finalContainer?.image?.minHeight : imgHeight)"
            [alt]="finalContainer?.image?.alt"
            [width]="100"
            [height]="100"
            [priority]="!!finalContainer?.isInitialLoading"
            (error)="finalContainer.image.path = null"
          >
        </a>
      </div>
    </div>
  }

</ng-template>

<ng-template #cardTemplate let-finalContainer="finalContainer"></ng-template>

<ng-template #wowTemplate let-finalContainer="finalContainer">
  <div (click)="goto(finalContainer)">
    @if (isDesktop) {
      <div [ngStyle]="{
          'background': finalContainer?.background ? 'linear-gradient(200deg,'+ finalContainer?.background + ',transparent)': 'transparent',
          'border-color': finalContainer?.borderColor,
         }" class="wowCard card">

        @if (finalContainer?.title) {
          <div class="flxBox">
            <div [ngStyle]="{
            'background-color': finalContainer?.background
           }"
                 class="wowSkeleton skeleton">{{ finalContainer?.title | titlecase }}
            </div>
          </div>
        }

        @if (finalContainer?.briefDescription) {
          <div class="wowDesc">
            <div class="desc">
              {{ finalContainer?.briefDescription }}
            </div>
          </div>
        }

        @if (finalContainer?.button; as buttonData) {
          <div class="wowBtn">
            <button>{{ buttonData?.title }}</button>
          </div>
        }
      </div>
    } @else {
      <!-- Mobile code -->
      <div [ngStyle]="{
          'background': finalContainer?.background ? 'linear-gradient(200deg,'+ finalContainer?.background + ',transparent)': 'transparent',
          'border-color': finalContainer?.borderColor,
         }" class="wowCard card">

        @if (finalContainer?.title) {
          <div class="flxBox">
            <div [ngStyle]="{
            'background-color': finalContainer?.background
           }"
                 class="wowSkeleton skeleton">{{ finalContainer?.title | titlecase }} {{ finalContainer?.subTitle }}
            </div>
          </div>
        }
      </div>
    }
  </div>

</ng-template>

<ng-template #defaultTemplate let-finalContainer="finalContainer">
  <div (click)="goto(finalContainer)">
    @if (isDesktop) {
      <div [ngStyle]="{
        'background': finalContainer?.background,
        'background-size': finalContainer?.backgroundSize,
        'background-position': finalContainer?.backgroundPosition,
        'border-color':finalContainer?.borderColor
      }" class="grid-box card">
        @if (finalContainer?.image?.path) {
          <div class="logo">
            <div class="img-wrap"
                 [ngStyle]="{'width': finalContainer?.image?.width,'height': finalContainer?.image?.height,}">
              <img
                [ngSrc]="finalContainer?.image?.path + '?format=webp&quality=' + imgQuality + '&height=' + imgHeight"
                [alt]="finalContainer?.image?.alt"
                [width]="100"
                [height]="100"
                [priority]="!!finalContainer?.isInitialLoading"
              >
            </div>
          </div>
        }
        <div class="content">
          @if (finalContainer?.title) {
            <div class="title">
              <span [innerHTML]="finalContainer?.title | safe: 'html'"
                    [ngStyle]="{'color': finalContainer?.textColor}"></span>
            </div>
          }
          <div class="desc">
            @if (finalContainer?.briefDescription) {
              <span class="save"
                    [ngStyle]="{'color': finalContainer?.textColor}">{{ finalContainer?.briefDescription }}</span>
            }
            @if (finalContainer?.priceDetail; as priceDetail) {
              @if (priceDetail?.rackRate) {
                <span
                  class="dis"><s>{{ priceDetail?.currency ?? '' }}{{ priceDetail?.rackRate }}</s></span>
              }
              @if (priceDetail?.offeredPrice) {
                <span
                  class="price"> {{ priceDetail?.currency ?? '' }}{{ priceDetail?.offeredPrice }}</span>
              }
              @if (priceDetail?.duration) {
                <span class="val">{{ priceDetail?.duration }}</span>
              }
            }
          </div>
        </div>
        @if (finalContainer?.button; as buttonData) {
          <div class="btn-wrap">
            <div class="btn">
              <button class="get-btn" aria-label="buy now">{{ buttonData?.title | titlecase }}</button>
            </div>
          </div>
        }
      </div>
    } @else {
      <!--mobile code-->
      <div [ngStyle]="{
        'background': finalContainer?.background,
        'background-size': finalContainer?.backgroundSize,
        'background-position': finalContainer?.backgroundPosition,
        'border-color':finalContainer?.borderColor
      }" class="grid-box card">
        @if (finalContainer?.image?.path) {
          <div class="logo">
            <div class="img-wrap"
                 [ngStyle]="{'width': finalContainer?.image?.width,'height': finalContainer?.image?.height,}">
              <img
                [ngSrc]="finalContainer?.image?.path + '?format=webp&quality=' + imgQuality + '&height=' + imgHeight"
                [alt]="finalContainer?.image?.alt"
                [width]="100"
                [height]="100"
                [priority]="!!finalContainer?.isInitialLoading"
              >
            </div>
          </div>
        }
        <div class="content">
          @if (finalContainer?.title) {
            <div class="title">
              <span [innerHTML]="finalContainer?.title | safe: 'html'"
                    [ngStyle]="{'color': finalContainer?.textColor}"></span>
            </div>
          }
          <div class="desc">
            @if (finalContainer?.briefDescription) {
              <span class="save"
                    [ngStyle]="{'color': finalContainer?.textColor}">{{ finalContainer?.briefDescription }}</span>
            }
            @if (finalContainer?.priceDetail; as priceDetail) {
              @if (priceDetail?.rackRate) {
                <span
                  class="dis"><s>{{ priceDetail?.currency ?? '' }}{{ priceDetail?.rackRate }}</s></span>
              }
              @if (priceDetail?.offeredPrice) {
                <span
                  class="price"> {{ priceDetail?.currency ?? '' }}{{ priceDetail?.offeredPrice }}</span>
              }
              @if (priceDetail?.duration) {
                <span class="val">{{ priceDetail?.duration }}</span>
              }
            }
          </div>
          @if (finalContainer?.button; as buttonData) {
            <div class="btn-wrap">
              <div class="btn">
                <button class="get-btn" aria-label="buy now">{{ buttonData?.title | titlecase }}</button>
              </div>
            </div>
          }
        </div>
      </div>
    }
  </div>

</ng-template>
